// accionesDeDiseno.ts — las acciones que se disparan desde la barra de CUALQUIER celda con
// imagen del lienzo de un diseño. No hay roles ni tipos: una base del catálogo, una foto
// subida, una creación elegida o un resultado tienen las mismas tres acciones
// (ADR-2026-09-17-todas-las-imagenes-tienen-las-mismas-acciones). La base descrita nace en
// la portada y no tiene botón.

import type { AccionDeDiseno } from './disenoGuardado';

export type AccionConBoton = Exclude<AccionDeDiseno, 'base-descrita'>;

export const ACCIONES_CON_BOTON: { accion: AccionConBoton; rotulo: string }[] = [
  { accion: 'en-uso', rotulo: 'Mostrar en uso' },
  { accion: 'mezcla', rotulo: 'Mezclar' },
  { accion: 'plano', rotulo: 'Plano técnico' },
];

/**
 * Al SALIR del lienzo, ¿hay que cerrar el panel lateral del agente?
 *
 * Adentro del diseño el panel se abre solo ("Agregar al chat" lo abre si estaba cerrado)
 * y, como un diseño ES un chat (ADR-2026-09-17-un-diseno-es-un-chat), lo que muestra es
 * la conversación de ESE diseño. Si se sale y queda abierto, la pantalla siguiente hereda
 * un chat que no es de lo que se está mirando (bug reportado el 2026-09-22).
 *
 * Se cierra sólo cuando el panel sigue siendo el de este diseño: si el usuario cambió de
 * conversación a mano, la apertura es suya y no se toca. En la pantalla dedicada del
 * agente no hay panel que cerrar.
 */
export function hayQueCerrarElPanelAlSalir(estado: {
  abierto: boolean;
  vista: 'panel' | 'pantalla';
  /** El chat que el agente tiene cargado en este momento. */
  chatId: string | null;
  disenoId: string;
}): boolean {
  return estado.abierto && estado.vista === 'panel' && estado.chatId === estado.disenoId;
}
